import {DEFAULT_HOST} from '@/utils/router'

export const getCountryGuideContent = () => ({
  metaTitle: 'country-guide.home-meta-title',
  metaDescription: 'country-guide.home-meta-description',
  ogImage: {
    url: `${DEFAULT_HOST}/images/og-images/country-guide-en.png`,
    width: 1200,
    height: 627,
    alt: 'Trademark guidance by country - OG image',
  },
  hero: {
    title: 'country-guide.home-hero-title',
    subtitle: 'country-guide.home-hero-subtitle',
  },
  searchTitle: 'country-guide.search-title',
  searchPlaceholder: 'select-country-placeholder',
  mostPopularCountriesTitle: 'country-guide.most-popular-countries-title',
  otherPopularCountriesTitle: 'country-guide.other-popular-countries-title',
  learnMoreText: 'learn-more-text',
  countrySpecific: {
    hero: {
      title: 'country-guide.country-hero-title',
      averageRegistrationTimeTitle: 'country-guide.average-registration-time-title',
      applicationsFiledPerYearTitle: 'country-guide.applications-filed-per-year-title',
      registrationPriceTitle: 'country-guide.registration-price-title',
      registrationPriceTooltip: 'country-guide.registration-price-tooltip',
      primaryButtonText: 'button-start-with-lawyer-check',
      secondaryButtonText: 'button-show-price-list',
      priceEstimateButtonText: 'country-guide.button-show-price-estimate',
    },
  },
})
